import { AxiosResponse } from 'axios';
import { orderBy, select } from 'utils/dynamic';
import { API, apiRtk, rtkAdapterDynamicToSource } from 'utils/service';
import { IDosageForm } from '__generated__/api';

type Source = Pick<IDosageForm, 'id' | 'isActive'> & { title: string }
export const apiDosageForms = apiRtk.injectEndpoints({
  endpoints: (build) => ({
    getSourceDosageForms: build.query<Array<Source>, void>({
      queryFn: async () => {
        const res = await API.api.dosageFormsGetAllDynamicCreate({
          select: select('id', 'catalogName as title', 'isActive'),
          orderBy: orderBy('catalogName', 'asc'),
        });

        return rtkAdapterDynamicToSource(res) as AxiosResponse<
          Array<Source>
        >;
      },
    }),
  }),
});
